import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    removeFromList: string;
    showInProject: string;
    viewLogFile: string;
    pause: string;
    resume: string;
    retry: string;
    forceFailure: string;
    progressTypeLabel: (batchType: string) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Menu button label to cancel a transfer */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to remove a completed transfer from the list */
            removeFromList: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.removeFromList?c=3oui32n2rnfy2", defaultMessage: "Remove From List" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to navigate to the project */
            showInProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.showInProject?c=2vztedo1jmpts", defaultMessage: "Show in Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to view the log file */
            viewLogFile: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.viewLogFile?c=xlo8esrp650u", defaultMessage: "View Log File" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to pause a transfer */
            pause: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.pause?c=3vln8o88rde2o", defaultMessage: "Pause" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to resume a paused transfer */
            resume: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.resume?c=uyaybnaadtfu", defaultMessage: "Resume" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu button label to retry a failed transfer */
            retry: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.retry?c=24r9hk1amvd4v", defaultMessage: "Retry" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dev-only menu button to force a transfer failure */
            forceFailure: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "JobControls.forceFailure?c=l0mncvaykyn1", defaultMessage: "Force Failure" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for transfer type based on batch type */
            progressTypeLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (batchType: string): string => __intl__.intl().formatMessage({ id: "JobControls.progressTypeLabel?c=1qv4xpaeh8ocj", defaultMessage: "{batchType, select, DOWNLOAD {Download} RENDER {Export} UPLOAD {Upload} other {}}" }, { batchType: batchType }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
